export function impressionAnalytics(data) {
  if (!data) {
    throw new Error('Impression data sent to analytics is null or undefined');
  }
  return new Promise((resolve, reject) => {
    resolve(
      window.LIFE_CYCLE_EVENT_BUS.trigger('impression.trigger', data)
    );
  });
}
